export default __webpack_public_path__ + "static/media/cable3.5d793341.png";